<div class="modal-header"  *ngIf="IsModal" >
  <h5 class="modal-title" id="editUserLabel">Task</h5>
  <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [ngClass]="{'': IsModal, 'card': !IsModal }">
  <div [ngClass]="{'modal-body': IsModal, 'card-body': !IsModal }">
    <div class="col-md-12 ">
      <div class="form-group">
        <label for="nome" class="control-label col-form-label">Titolo:</label>
        <input type="text" #nome="ngModel" required [readOnly]="selected?.id" [(ngModel)]="selected.nome" class="form-control" id="nome" placeholder="Titolo">
        <small class="form-text text-danger" *ngIf="!nome.valid && (nome.dirty || nome.touched)">Campo richiesto!</small>
      </div>
    </div>
    <div class="col-md-12 ">
      <div class="form-group">
        <label for="desc" class="control-label col-form-label">Descrizione:</label>
        <textarea type="text" #desc="ngModel" required [(ngModel)]="selected.note" [readOnly]="selected?.id" class="form-control" id="desc" placeholder="Descrizione"></textarea>
        <small class="form-text text-danger" *ngIf="!desc.valid && (desc.dirty || desc.touched)">Campo richiesto!</small>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <label for="tipo" class="control-label col-form-label">Tipo</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Seleziona'" id="tipo" [data]="tipi" [(ngModel)]="tipiselezionati"></ng-multiselect-dropdown>
      </div>
    </div>
    <div class="col-lg-3" *ngIf="selected?.id">
      <div class="form-group">
        <label for="stato" class="control-label col-form-label">Stato</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [disabled]="!permission.isPermitted('gestione-ticket')" [placeholder]="'Seleziona'" id="stato" [data]="stati" [(ngModel)]="statiselezionati" ></ng-multiselect-dropdown>
      </div>
    </div>
    <div class="col-md-12 " *ngIf="selected?.id">
      <div class="form-group">
        <label for="closed" class="control-label col-form-label">Concluso:</label>
        <input type="checkbox" #nome="ngModel" [readOnly]="!permission.isPermitted('gestione-ticket')"  [(ngModel)]="selected.chiuso" class="form-control" id="closed">
      </div>
    </div>
    <div class="col-md-12 " *ngIf="selected?.id && permission.isPermitted('gestione-ticket')">
      <div class="form-group">
        <label for="notaInterna" class="control-label col-form-label">Nota Interna:</label>
        <textarea type="text" #notaInterna="ngModel" [(ngModel)]="selected.notaInterna" class="form-control" id="notaInterna" placeholder="Nota Interna"></textarea>
        <small class="form-text text-danger" *ngIf="!notaInterna.valid && (notaInterna.dirty || notaInterna.touched)">Campo richiesto!</small>
      </div>
    </div>
    <div class="col-md-12 " *ngIf="selected?.id">
      <div class="form-group">
        <label for="notaChiusura" class="control-label col-form-label">Nota Chiusura:</label>
        <textarea type="text" #notaChiusura="ngModel" [readOnly]="!permission.isPermitted('gestione-ticket')" [(ngModel)]="selected.notaChiusura" class="form-control" id="notaChiusura" placeholder="Nota Chiusura"></textarea>
        <small class="form-text text-danger" *ngIf="!notaChiusura.valid && (notaChiusura.dirty || notaChiusura.touched)">Campo richiesto!</small>
      </div>
    </div>
  </div>
  <div *ngIf="selected?.id">
    <hr>
    <app-file-uploader [url]="'/task/ticket/file'" [(id)]="selected.id" (onChange)="onFileChanged()"></app-file-uploader>
  </div>
</div>
<div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10">
  <button type="submit" (click)="saveClick()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Salva </span>
    <i-feather name="save" class="feather-md "></i-feather>
  </button>
</div>
